import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import { SplashScreen } from 'src/components/loading-screen';
import { PATHS } from 'src/routes/paths';
import { lazyPage } from 'src/routes/lazy-page';

const OauthConsentPage = lazyPage(() => import('src/pages/oauth/consent'), ['oauth-consent']);

// The API redirects the browser here mid-OAuth. It needs a signed-in user — AuthGuard keeps the
// `request_id` through login via `returnTo` — but no platform and no app chrome at all: picking the
// schools is what the page is for, and it draws its own bare column.
export const oauthRoutes = [
  {
    element: (
      <AuthGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </AuthGuard>
    ),
    children: [{ path: PATHS.oauth.consent, element: <OauthConsentPage /> }],
  },
];
